import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../lib/firebase";
import Trade from "../components/dashboard/Trade";
import Funding from "../components/stocks/Funding";
import Loader from "../components/Loader";
import "../styles/fxttrade.css";
import MarketMarquee from "../components/stocks/MarketMarque";

function FxtTrade({ user }) {
  const navigate = useNavigate();
  const [accountBalances, setAccountBalances] = useState({});
  const [loading, setLoading] = useState(true);
  const [plans, setPlans] = useState([]);
  const [hasActiveTrade, setHasActiveTrade] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userDoc = await getDoc(doc(db, "users", user.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          const transactions = userData.transactions || [];

          const balances = {};
          transactions.forEach((txn) => {
            if (!balances[txn.account]) {
              balances[txn.account] = 0;
            }
            if (txn.type === "credit") {
              balances[txn.account] += txn.amount;
            } else if (txn.type === "debit") {
              balances[txn.account] -= txn.amount;
            }
          });

          setAccountBalances(balances);
          setHasActiveTrade(!!userData.activeTrade);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (user && user.uid) {
      fetchData();
    }
  }, [user]);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const docRef = doc(db, "users", "plans");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const plansData = docSnap.data();
          const plansArray = Object.entries(plansData).map(([key, plan]) => ({
            key,
            ...plan,
          }));

          setPlans(plansArray);
        }
      } catch (err) {
        console.error("Error fetching plans:", err);
      }
    };

    fetchPlans();
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="skyfxt-box">
      <MarketMarquee />
      <Trade user={user} accountBalances={accountBalances} />

      {hasActiveTrade ? (
        <div style={{ marginTop: "20px" }}>
          <Funding />
        </div>
      ) : (
        <section className="plans-display-section">
          <h2 className="section-title">Investment Plans</h2>
          <p className="section-subtitle">
            Choose a plan that suits your investment goals.
          </p>
          <div className="plans-grid">
            {plans.length > 0 ? (
              plans.map((plan) => {
                let specsArr = [];
                if (Array.isArray(plan.specs)) {
                  specsArr = plan.specs;
                } else if (plan.specs && typeof plan.specs === "object") {
                  specsArr = Object.values(plan.specs).filter(
                    (v) => typeof v === "string",
                  );
                }

                return (
                  <div
                    key={plan.key}
                    className="plan-card-click"
                    onClick={() => navigate(`/investments/${plan.key}`)}
                  >
                    <h3 className="plan-card-name">{plan.name}</h3>
                    <span className="plan-card-price">{plan.price}</span>

                    {plan.hardware && (
                      <div className="card-hardware">{plan.hardware}</div>
                    )}

                    {specsArr.length > 0 && (
                      <div className="card-perks">
                        <span className="perks-label">Perks:</span>
                        <ul>
                          {specsArr.map((spec, idx) => (
                            <li key={idx}>{spec}</li>
                          ))}
                        </ul>
                      </div>
                    )}

                    <div className="plan-card-stats">
                      <span>{plan.durationDisplay}</span>
                      <span className="profit">+{plan.profit}%</span>
                    </div>
                  </div>
                );
              })
            ) : (
              <p className="loading">No plans available</p>
            )}
          </div>
        </section>
      )}
    </div>
  );
}

export default FxtTrade;
